import { Button, Box, TextField, FormControl } from "@mui/material";
import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";

const setGearQtyPattern = function (validationData) {
  if (
    validationData &&
    validationData.hasOwnProperty("QUANTITY_MINIMUM") &&
    validationData.hasOwnProperty("QUANITY_MAXIMUM")
  ) {
    return (
      validationData.QUANTITY_MINIMUM + " - " + validationData.QUANITY_MAXIMUM
    );
  }
  return "no valid pattern";
};

const styles = {
  numberInput: {
    textAlign: "center",
    alignSelf: "leftmm",
  },
};

export default function GearQty(props) {
  // * Created unique array to avoid duplicate buttons with same value
  const uniqueGearPreference = [
    ...props.gear_preference
      .reduce(
        (gear_preference, obj) => gear_preference.set(obj.gearqty, obj),
        new Map()
      )
      .values(),
  ];
  return (
    <Box mt={0} width="100%" align="center" key={"gear_qty_box"}>
      <h2 className="sectionTitle center">Gear Quantity</h2>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        key={"gear_qty_grid"}
      >
        <Grid item xs={12} md="auto" key={"gear_qty_item"}>
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            key={"gear_qty_item_box"}
          >
            {uniqueGearPreference.map(
              (gear_code, idx) =>
                props.gearcode === gear_code.gearcode && (
                  <Box m={0.5} key={"gear_qty_box_" + idx}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className="form-input"
                      data-new-value={gear_code.gearqty}
                      data-field={"gearqty"}
                      size="large"
                      onClick={(e) =>
                        props.handleGearPreferenceChange(e, gear_code.gearqty)
                      }
                      id={gear_code.gearcode + gear_code.gearsize}
                      key={gear_code.gearcode + gear_code.gearsize}
                    >
                      {gear_code.gearqty}
                    </Button>
                  </Box>
                )
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md="auto" key={"gear_qty_field_grid"}>
          <FormControl>
            <TextField
              variant="standard"
              label="Gear Qty:"
              className="number-of-input"
              inputProps={{ min: 0, style: styles.numberInput }}
              value={props.gearqty ? Number(props.gearqty) : ""}
              name="gearqty"
              type="number"
              onChange={(e) => props.handleInputChange(e)}
              helperText={setGearQtyPattern(props.validation)}
              key={"gear_qty_field"}
            />
          </FormControl>
          <HelpText helpText={getHelpText(props.helpText, "gear_qty")} />
        </Grid>
      </Grid>
    </Box>
  );
}
